export const faqs = [
  {
    question: "磁力搜索和普通的BT搜索有什么区别？",
    answer: "磁力搜索基于DHT分布式网络，不需要Tracker服务器就能定位资源，而传统BT搜索依赖中心化的Tracker服务器。磁力搜索更去中心化、更稳定、更难被封锁，是目前主流的P2P资源检索方式。",
  },
  {
    question: "如何判断一个磁力链接是否安全？",
    answer: "判断磁力链接安全性的方法包括：查看资源评论区是否有恶意报告、检查文件名和格式是否合理（警惕.exe/.scr等可执行文件伪装成视频文件）、使用在线磁力链接分析工具检查内容、选择信誉良好的搜索引擎和发布源。",
  },
  {
    question: "为什么磁力搜索有些结果打不开或下载很慢？",
    answer: "这通常是因为资源的种子数量不足或做种者已离线。磁力搜索依赖于P2P网络中其他用户的上传，如果做种者很少或网络连接质量差，下载速度就会受影响。可以尝试选择种子数更多的资源，或添加更多Tracker服务器来改善连接。",
  },
  {
    question: "使用磁力搜索需要安装什么软件？",
    answer: "基础的磁力搜索只需要一个浏览器访问磁力搜索引擎即可。但找到资源后需要用BT下载客户端来下载，推荐使用qBittorrent、Transmission等免费工具。此外，为了安全建议配备VPN和杀毒软件。",
  },
  {
    question: "磁力链接的格式是什么样的？怎样使用？",
    answer: "磁力链接的标准格式为：magnet:?xt=urn:btih:[哈希值]，后面还可能带有dn（文件名）、tr（tracker地址）等参数。使用时将完整的磁力链接复制到BT下载客户端中，客户端会自动解析并开始下载。大多数现代浏览器和下载工具都支持直接点击磁力链接启动下载。",
  },
  {
    question: "为什么有些资源搜不到？",
    answer: "搜不到资源可能有几个原因：资源过于冷门或老旧导致DHT网络中没有活跃节点；关键词不准确（尝试使用原名、别名或不同拼写）；搜索引擎的数据库覆盖范围有限（换一个搜索引擎再试）。对于特别冷门的资源，可以尝试在专业论坛寻找磁力链接分享。",
  },
  {
    question: "磁力搜索有哪些法律风险需要注意？",
    answer: "磁力搜索和下载的合法性取决于所下载内容本身是否受版权保护以及你所在地区的法律规定。许多国家/地区对受版权保护内容的未授权下载有法律限制。建议仅搜索和下载版权过期或开放许可的合法内容，或通过合法付费渠道获取所需资源。",
  },
];